import validate from "/builds/sites/wnhub-general-client/node_modules/nuxt/dist/pages/runtime/validate.js";
import profile_45global from "/builds/sites/wnhub-general-client/middleware/profile.global.ts";
import redirect_45global from "/builds/sites/wnhub-general-client/middleware/redirect.global.ts";
import manifest_45route_45rule from "/builds/sites/wnhub-general-client/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  profile_45global,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/sites/wnhub-general-client/middleware/auth.ts")
}